import { colorsPalettes } from "@similarweb/styles";
import { Text, Flex, Stack } from "@similarweb/ui-components/foundations";

import { NumberFormatter } from "app/common/utils/number-formatter";
import { IndicatorBadge } from "app/pages/digital-marketing/common/ui/IndicatorBadge/IndicatorBadge";
import { InfoTooltip } from "app/pages/digital-marketing/common/ui/InfoTooltip";

import { LoadingSkeleton } from "./LoadingSkeleton";
import { MetricsGraph } from "./MetricsGraph";
import { MetricsProgress } from "./MetricsProgress";
import { MetricsWidgetContainer } from "./styled";
import type { IMetricsWidgetProps } from "./types";

export const MetricsWidget = ({
    title,
    value,
    valueFormatter,
    change,
    children,
    precision = 1,
    helpText = "Some help text",
    behavior = "normal",
    isLoading,
}: IMetricsWidgetProps) => {
    if (isLoading) {
        return <LoadingSkeleton />;
    }

    return (
        <MetricsWidgetContainer
            gap="16px"
            width="100%"
        >
            <Stack
                gap="16px"
                width="100%"
            >
                <Flex
                    gap="8px"
                    alignItems="center"
                >
                    {typeof title === "string" ? (
                        <Text
                            fontVariant="subtitle2"
                            color={colorsPalettes.carbon["400"]}
                        >
                            {title}
                        </Text>
                    ) : (
                        title
                    )}
                    <InfoTooltip content={helpText} />
                </Flex>

                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <Text
                        fontVariant="h4"
                        color={colorsPalettes.carbon["500"]}
                    >
                        {valueFormatter === "toPercent"
                            ? NumberFormatter.toPercent(value, precision, "—")
                            : valueFormatter === "toAbbr"
                              ? NumberFormatter.toAbbr(value, precision, "—")
                              : NumberFormatter.toSmartPercent(value, "—")}
                    </Text>
                    {change != null ? (
                        <IndicatorBadge
                            value={change}
                            behavior={behavior}
                            label="PoP"
                        />
                    ) : null}
                </Flex>
            </Stack>
            {children}
        </MetricsWidgetContainer>
    );
};

MetricsWidget.Progress = MetricsProgress;
MetricsWidget.Graph = MetricsGraph;
